import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function Introduction() {
  const features = [
    {
      icon: 'ri-medal-line',
      title: 'Premium Quality',
      desc: 'Every product is sourced from trusted manufacturers and meets strict quality standards.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Fast Delivery',
      desc: 'We deliver directly to your site or home, saving you time and effort.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Best Prices',
      desc: 'Competitive pricing on all products with bulk discounts available.'
    }
  ];

  const textAnim = useScrollAnimation({ threshold: 0.2 });
  const cardsAnim = useStaggerAnimation(features.length, { threshold: 0.15 });

  return (
    <section id="introduction" className="py-14 lg:py-24 bg-[#141414]">
      <div className="max-w-7xl mx-auto px-5 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: Text */}
          <div
            ref={textAnim.ref}
            className={`transition-all duration-700 ${textAnim.isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}
          >
            <div className="inline-flex items-center gap-2 bg-[#FF6600]/20 border border-[#FF6600]/40 text-[#FF6600] px-3 py-1.5 lg:px-4 lg:py-2 rounded-full text-xs font-semibold uppercase tracking-widest mb-4 lg:mb-6">
              <i className="ri-information-line"></i>
              About Us
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-extrabold text-white leading-tight mb-4 lg:mb-6">
              Your Trusted Partner in
              <span className="text-[#FF6600]"> Building Excellence</span>
            </h2>
            <p className="text-white/60 text-sm lg:text-base leading-relaxed mb-3 lg:mb-5">
              We are a premier supplier of high-quality building materials, bathroom fixtures, flooring solutions, and interior finishes. Whether you are a homeowner, contractor, or designer — we have everything you need to bring your vision to life.
            </p>
            <p className="text-white/60 text-sm lg:text-base leading-relaxed mb-6 lg:mb-10">
              Our curated selection spans five major categories: Flooring, Sanitary &amp; Bathroom, Kitchen, Structural, and Interior Surface Finishes — all under one roof, with expert guidance every step of the way.
            </p>
            <button
              onClick={() => {
                const el = document.getElementById('products');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-2 bg-[#FF6600] text-white px-6 py-3 lg:px-8 lg:py-4 rounded-full hover:bg-[#E55A00] transition-all duration-300 hover:scale-105 font-semibold text-sm whitespace-nowrap cursor-pointer shadow-lg shadow-[#FF6600]/30"
            >
              Browse Products
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          {/* Right: Feature cards */}
          <div ref={cardsAnim.ref} className="grid grid-cols-1 gap-3 lg:gap-5">
            {features.map((f, i) => (
              <div
                key={f.title}
                style={cardsAnim.getItemStyle(i)}
                className="bg-[#1A1A1A] border border-white/5 rounded-xl lg:rounded-2xl p-4 lg:p-6 hover:border-[#FF6600]/30 transition-all duration-300 group hover:-translate-y-1 hover:shadow-lg hover:shadow-[#FF6600]/5"
              >
                <div className="w-9 h-9 lg:w-12 lg:h-12 flex items-center justify-center bg-[#FF6600]/10 rounded-lg lg:rounded-xl mb-3 lg:mb-4 group-hover:bg-[#FF6600]/20 group-hover:scale-110 transition-all duration-300">
                  <i className={`${f.icon} text-[#FF6600] text-lg lg:text-2xl`}></i>
                </div>
                <h3 className="text-white font-bold text-sm lg:text-base mb-1 lg:mb-2">{f.title}</h3>
                <p className="text-white/50 text-xs lg:text-sm leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
